import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useRecoilState, useRecoilValue } from "recoil";
import useExamRoomActions from "../../../api/hooks/admin/examRoom";
import { isRaterAddModalOpenState } from "../../../recoil/admin/examRoom";
import { testRoomSnState } from "recoil/auth";
import Modal from "../../modules/layout/Modal";

const RaterAddModal = () => {
  const { register, handleSubmit, reset, watch } = useForm();

  const [isRaterModalOpen, setRaterModalOpen] = useRecoilState(
    isRaterAddModalOpenState
  );
  const selectedTestRoomSn = useRecoilValue(testRoomSnState);

  const { addRater, fetchAllRaterList } = useExamRoomActions();

  const [selectedRaters, setSelectedRaters] = useState([]);
  const stateReset = () => {
    setSelectedRaters([]);
  };
  // Access the client
  const queryClient = useQueryClient();

  // Mutations
  const mutation = useMutation(addRater, {
    onSuccess: () => {
      alert("평가자를 추가했습니다.");
      setRaterModalOpen(false);
      // Invalidate and refetch
      queryClient.invalidateQueries(["fetchRaterList"]);
      stateReset();
      return;
    },
    onError: () => {
      alert("실패");
    },
  });

  // Queries
  const { data: raterList } = useQuery(["fetchAllRaterList"], () =>
    fetchAllRaterList()
  );
  // console.log("all raterList", raterList);
  // console.log("selectedRaters", selectedRaters);

  const onSubmit = (data) => {
    const req = {
      room_sn: selectedTestRoomSn,
      rater_sn: selectedRaters,
    };
    // console.log("req", req);

    mutation.mutate(req);
  };
  return (
    <Modal isOpen={isRaterModalOpen}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="modal fade" id="plus" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header flex">
                <p className="sign-top-title" id="staticBackdropLabel">
                  OPIC 평가자등록
                </p>
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setRaterModalOpen(false);
                    stateReset();
                  }}
                ></button>
              </div>
              <div className="modal-body confirm-sec">
                <div className="modal-title">
                  <p>평가자 등록</p>
                </div>
                <div className="modal-cont">
                  <div className="overflow-scroll height-300">
                    <table className="plus2-table">
                      <thead>
                        <tr>
                          <th className="text-align-left">이름(아이디)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {raterList?.data?.map((rater) => (
                          <tr key={rater?.sn}>
                            <td>
                              <div className="rater-choice flex">
                                <p className="rater-name">
                                  {rater?.name}({rater?.id})
                                </p>
                                <div className="radio-container-plus-box">
                                  <label className="radio-container-plus">
                                    <input
                                      className="agree"
                                      type="checkbox"
                                      onClick={() => {
                                        if (
                                          selectedRaters.includes(rater?.sn)
                                        ) {
                                          const nextState = [...selectedRaters];
                                          const idx = nextState.indexOf(
                                            rater?.sn
                                          );
                                          nextState.splice(idx, 1);
                                          setSelectedRaters(nextState);
                                        } else {
                                          setSelectedRaters([
                                            ...selectedRaters,
                                            rater?.sn,
                                          ]);
                                        }
                                      }}
                                      value={selectedRaters.includes(rater?.sn)}
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer text-align-right">
                  <button
                    type="button"
                    className="modal-btn modal-close-btn"
                    onClick={() => {
                      setRaterModalOpen(false);
                      stateReset();
                    }}
                  >
                    닫기
                  </button>
                  <button type="submit" className="modal-btn modal-save-btn">
                    완료
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default RaterAddModal;
